export default "__VITE_ASSET__qXpgoBkS__"